export const PAYEE_FORM_MAX_LENGTH = {
  CONTACT_PERSON_NAME: 100,
  CONTACT_DEPARTMENT: 100,
  CONTACT_EMAIL: 100,
  CONTACT_PHONE_NUMBER: 20,
  CONTACT_ADDRESS: 255,
  OFFICE_MEMBERS: 15,
  TRANSACTION_NAME: 100,
} as const;
